import $ from 'jquery';
import inView from 'in-view';

$(function() {
    // Services Tiles
    function removeClassFromSiblingTiles(currentTile) {
        const tiles = document.querySelectorAll('.tile');
        tiles.forEach((tile) => {
            if (tile !== currentTile) {
                tile.classList.remove('in-view');
            }
        });
    }
    if (window.matchMedia('(pointer: coarse)').matches && document.querySelectorAll('.services-container-tuiles').length > 0) {
        inView('.tile')
            .on('enter', (tile) => {
                tile.classList.add('in-view');
                removeClassFromSiblingTiles(tile);
            })
            .on('exit', (tile) => {
                tile.classList.remove('in-view');
            });

        inView.threshold(0.5);
    }
});
